export default __webpack_public_path__ + "static/service-residential-df4833a1070adad15d49c3774041847a.jpg";